// extracted by mini-css-extract-plugin
export default {"background":"SalaryModal_background__jXuqt","modal":"SalaryModal_modal__C1maM","viddo_modal":"SalaryModal_viddo_modal__DYdWh","btn_main":"SalaryModal_btn_main__6e+bL"};